import { Backdrop, Button, CircularProgress, createTheme, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import axios from "axios";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Header from "./components/Header";
import AdmPartidas from "./components/Partidas/adm";

import './Jogos.css';



function AdmJogos({fase}) {

  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            fontSize: '1.1rem',
            color: 'grey',
            padding: '0'
          },
          body: {
            fontSize: '14px',
            color: 'white',
            textAlign: 'center',
            padding: '10px 0 0 0px',
            border: '1',
            fontFamily: 'Inter',
            lineHeight: '20px'
          }
        },
      },
    },
  });

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [times, setTimes] = useState([]);
  const [timesEditados, setTimesEditados] = useState({});

  const [resultados] = useState([]);
  const handleResultado1 = (e) => {
    let valor = (e.target.value === '' || e.target.value === null) ? -1 : parseInt(e.target.value);
    let index = resultados.findIndex((obj => obj.ID === parseInt(e.target.id)));
    if (index === -1)
      resultados.push({ 'ID': parseInt(e.target.id), 'R1': valor, 'R2': -1 });
    else
      resultados[index].R1 = valor;
  }

  const handleResultado2 = (e) => {
    let valor = (e.target.value === '' || e.target.value === null) ? -1 : parseInt(e.target.value);
    let index = resultados.findIndex((obj => obj.ID === parseInt(e.target.id)));
    if (index === -1)
      resultados.push({ 'ID': parseInt(e.target.id), 'R1': -1, 'R2': valor });
    else
      resultados[index].R2 = valor;
  }

  const handleTime1 = (gameId, value) => {
    setTimesEditados(prev => ({ ...prev, [gameId]: { ...prev[gameId], TIME1: value } }));
  };

  const handleTime2 = (gameId, value) => {
    setTimesEditados(prev => ({ ...prev, [gameId]: { ...prev[gameId], TIME2: value } }));
  };

  const [infos, setMessage] = useState([]);
  let navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setOpen(true);

    const reqJogos = axios.get(process.env.REACT_APP_BACKEND+'backend/adm/lista_jogos.php', {
      headers: { 'Authorization': `Bearer ${localStorage.getItem("token_bolaodojuca")}` }
    });

    const reqTimes = fase === 'FaseEliminatorias'
      ? axios.get(process.env.REACT_APP_BACKEND+'backend/grupos/', {
          headers: { 'Authorization': `Bearer ${localStorage.getItem("token_bolaodojuca")}` }
        })
      : Promise.resolve(null);

    Promise.all([reqJogos, reqTimes])
      .then(([jogosRes, timesRes]) => {
        const filtered = fase === 'FaseGrupos'
          ? jogosRes.data.filter(i => i.ID < 8)
          : jogosRes.data.filter(i => i.ID > 7);

        setMessage(filtered);

        if (timesRes) {
          const allTimes = timesRes.data
            .flatMap(g => g.TIMES)
            .sort((a, b) => a.NOME.localeCompare(b.NOME));
          setTimes(allTimes);

          const inicial = {};
          filtered.forEach(grupo => {
            grupo.JOGOS.forEach(jogo => {
              inicial[jogo.ID] = { TIME1: jogo.TIME1_ID, TIME2: jogo.TIME2_ID };
            });
          });
          setTimesEditados(inicial);
        }

        setLoading(false);
        setOpen(false);
      })
      .catch(() => {
        localStorage.removeItem("token_bolaodojuca");
        navigate('/');
      });

  }, [fase, navigate]);

  const handleEnviaChutes = () => {
    setLoading(true);
    setOpen(true);
    const path = fase === "FaseGrupos" ? "cadastra_resultadosGRU.php" : "cadastra_resultadosELI.php";

    let payload;
    if (fase === 'FaseEliminatorias') {
      const allGames = [];
      infos.forEach(grupo => grupo.JOGOS.forEach(jogo => allGames.push(jogo)));

      payload = allGames.map(jogo => {
        const res = resultados.find(r => r.ID === jogo.ID);
        const t = timesEditados[jogo.ID] || { TIME1: jogo.TIME1, TIME2: jogo.TIME2 };
        return {
          ID:    jogo.ID,
          R1:    res ? res.R1 : jogo.RESULTADO1,
          R2:    res ? res.R2 : jogo.RESULTADO2,
          TIME1: t.TIME1,
          TIME2: t.TIME2,
        };
      });
    } else {
      payload = resultados;
    }

    axios.post(process.env.REACT_APP_BACKEND+'backend/adm/'+path,
      JSON.stringify(payload),
      { headers: { 'Authorization': `Bearer ${localStorage.getItem("token_bolaodojuca")}` } }
    )
    .then(() => { window.location.reload(); })
    .catch(() => {
      localStorage.removeItem("token_bolaodojuca");
      navigate('/');
    });
  }

  return (
    <div className='Main_Home'>
      <Header fase={fase}/>
      <div className="Body_Grupos">
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} />
        {loading
          ? <div style={{display: 'flex', justifyContent: 'center'}}>
              <CircularProgress status="loading" />
            </div>
          :
          <Table sx={{ maxWidth: 375 }} >
            <TableHead>
              <TableRow>
                <TableCell align="center" theme={theme}>Time 1</TableCell>
                <TableCell align="center" theme={theme} colSpan={3}>VS</TableCell>
                <TableCell align="center" theme={theme}>Time 2</TableCell>
                {fase === 'FaseEliminatorias' && (
                  <TableCell align="center" theme={theme}>Data</TableCell>
                )}
              </TableRow>
            </TableHead>

            {infos.map((grupo) => (
              <TableBody key={grupo.FASE}>
                <TableRow>
                  <TableCell className="nome_rodada" colSpan={5} theme={theme}>{grupo.FASE}</TableCell>
                </TableRow>
                <AdmPartidas
                  key={grupo.ID + fase}
                  partidas={grupo.JOGOS}
                  funcao1={handleResultado1}
                  funcao2={handleResultado2}
                  times={fase === 'FaseEliminatorias' ? times : null}
                  timesEditados={timesEditados}
                  funcaoTime1={handleTime1}
                  funcaoTime2={handleTime2}
                />
              </TableBody>
            ))}
          </Table>
        }
        <div className="botao_enviarChutes">
          <Button variant="contained" onClick={handleEnviaChutes}>Enviar Chutes</Button>
        </div>
      </div>
    </div>
  );
}


export default AdmJogos;
